import { h, Component } from 'preact';
import Markup from 'preact-markup';

import style from './style.less';

import { showPromo, hidePromo } from '../../../lib/promo';
import { configure } from '../../../config';

import { Button, Icon } from '@cube/blocks';
import { trackingProvider, trackEvent, INPUT_KEYS, DIMENSION, EVENT, INTERACTION } from '@cube/track';
import isAllowed from '@cube/restrictions';


class PromoCard extends Component {

	buttonClick = () => {
		if (this.props.showClose && this.props.closeOnAction) {
			hidePromo(this.props);
			this.setState({
				showPromo: false
			});
		}

		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.contentid]: this.props.id,
			[DIMENSION.linkurl]: this.props.button.url,
			[DIMENSION.text]: this.props.button.text
		});

		if (this.props.button.openInNewWindow) {
			return window.open(this.props.button.url);
		}
		window.location = this.props.button.url;
	};

	closePromo = () => {
		hidePromo(this.props);

		trackEvent(this.context, {
			[INPUT_KEYS.action]: EVENT.click,
			[DIMENSION.contentid]: this.props.id,
			[DIMENSION.interaction]: INTERACTION.dismiss
		});

		this.setState({
			showPromo: false
		});
	};

	desktopDefault({ mainText, subText, showClose, button, url, image }) {
		return (
			<a href={url} class={style.hrefWrapper} >
				<div class={style.desktopDefault} >
					{ showClose &&
						<div class={style.close} onClick={this.closePromo}>
							<Icon name="exit-wire-cube" />
						</div>
					}
					<div class={style.content}>
						<div class={style.mainText}>
							<Markup markup={mainText} type="html" trim={false} />
						</div>
						<div class={style.subText}>
							<Markup markup={subText} type="html" trim={false} />
						</div>
						{ button &&
							<Button onClick={this.buttonClick} class={style.button}>
								{button.text}
							</Button>
						}
						{ image &&
							<img class={style.image} src={image} />
						}
					</div>
				</div>
			</a>
		);
	}

	desktopCentered({ mainText, subText, showClose, button, url }) {
		return (
			<a href={url} class={style.hrefWrapper} >
				<div class={style.desktopCentered} >
					{ showClose &&
						<div class={style.close} onClick={this.closePromo}>
							<Icon name="exit-wire-cube" />
						</div>
					}
					<div class={style.content}>
						<div class={style.mainText}>
							<Markup markup={mainText} type="html" trim={false} />
						</div>
						{ button &&
							<Button onClick={this.buttonClick} class={style.button}>
								{button.text}
							</Button>
						}
						{ subText &&
							<div class={style.subText}>
								<Markup markup={subText} type="html" trim={false} />
							</div>
						}
					</div>
				</div>
			</a>
		);
	}

	desktopSkinny({ mainText, subText, showClose, button, url }) {
		return (
			<a href={url} class={style.hrefWrapper} >
				<div class={style.desktopSkinny} >
					{ showClose &&
						<div class={style.close} onClick={this.closePromo}>
							<Icon name="exit-wire-cube" />
						</div>
					}
					<div class={style.content}>
						<div class={style.mainText}>
							<Markup markup={mainText} type="html" trim={false} />
						</div>
						{ button &&
							<Button onClick={this.buttonClick} class={style.button}>
								{button.text}
							</Button>
						}
					</div>
					{ subText &&
						<div class={style.subText}>
							<Markup markup={subText} type="html" trim={false} />
						</div>
					}
				</div>
			</a>
		);
	}

	desktopWithBackgroundImg({ mainText, subText, showClose, button, url, backgroundImage, width, height }) {
		const backgroundStyle = {
			backgroundImage: `url(${backgroundImage})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			width: width || '100%',
			height: height || '100%'
		};

		return (
			<a href={url} class={style.hrefWrapper}>
				<div class={style.desktopWithBackgroundImg} style={backgroundStyle}>
				
					<div class={style.contentWrapper}>
						<div class={style.content}>
							<div class={style.mainText}>
								<Markup markup={mainText} type="html" trim={false} />
							</div>
							<div class={style.subText}>
								<Markup markup={subText} type="html" trim={false} />
							</div>
						</div>
						<div class={style.btnCotainer}>
							{button && (
								<Button onClick={this.buttonClick} class={style.button}>
									{button.text}
								</Button>
							)}
							{showClose && (
								<div class={style.close} onClick={this.closePromo}>
									<Icon name="close-cube" />
								</div>
							)}
						</div>
					</div>
				</div>
			</a>
		);
	}

	mobile({ mainText, subText, button, image, url, showClose }) {
		return (
			<a href={url} >
				<div class={style.mobile} >
					{ showClose &&
						<div class={style.close} onClick={this.closePromo}>
							<Icon name="exit-wire-cube" />
						</div>
					}
					<div class={style.content}>
						{ mainText &&
							<div class={style.mainText}>
								<Markup markup={mainText} type="html" trim={false} />
							</div>
						}
						{
							image &&
							<img class={style.image} src={image} />
						}
						{ button &&
							<Button onClick={this.buttonClick} class={style.button}>
								{button.text}
							</Button>
						}
						{ subText &&
							<div class={style.subText}>
								<Markup markup={subText} type="html" trim={false} />
							</div>
						}
					</div>
				</div>
			</a>
		);
	}

	componentWillMount() {
		if (showPromo(this.props)) {
			this.setState({
				showPromo: true
			});
		}

		if (this.props.styles) {
			let head = document.head || document.getElementsByTagName('head')[0],
				style = document.createElement('style');

			head.appendChild(style);

			style.type = 'text/css';
			style.appendChild(document.createTextNode(this.props.styles));
		}
	}

	render({ layout, ...props }, { showPromo }) {
		if (!showPromo) return;

		if (layout === 'desktopCentered') return this.desktopCentered(props);
		if (layout === 'desktopSkinny') return this.desktopSkinny(props);
		if (layout === 'desktopWithBackgroundImg') return this.desktopWithBackgroundImg(props);
		if (layout === 'mobile') return this.mobile(props);
		return this.desktopDefault(props);
	}
}


@trackingProvider({
	[DIMENSION.componentpath]: 'PromoCluster'
})
@configure({
	locationServiceOrigin: 'locationServiceOrigin',
	restrictions: 'restrictions'
})
export default class PromoCluster extends Component {

	getPromoCard = (cards) => {
		if (!Array.isArray(cards)) return cards;

		return cards[Math.floor(Math.random()*cards.length)];
	};

	componentWillMount() {
		if (this.props.restriction) {
			this.setState( { deniedByRestriction: true });
			Promise.resolve(isAllowed(this.props.restriction, this.props))
				.then((res) => {
					this.setState( { deniedByRestriction: !res });
				});
		}
	}

	render({ primary, secondary, ...props }, { deniedByRestriction }) {
		if (deniedByRestriction) return;

		// Primary is required
		if (!primary) return;

		// if no Secondary then just show the Primary
		if (!secondary) return <PromoCard {...this.getPromoCard(primary)} />;

		return (
			<div class={style.list}>
				<div class={style.first}>
					<PromoCard {...this.getPromoCard(primary)} />
				</div>
				<div class={style.second}>
					<PromoCard {...this.getPromoCard(secondary)} />
				</div>
			</div>
		);
	}
}
